import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {Redirect} from 'react-router';
import SecuredLayout from './layout/secured-layout';
import AdminLayout from './layout/admin-layout';
import SecuredLayoutWOMenu from './layout/secured-layout-wo-menu';
import Auth from './auth/auth';

import Login from './pages/login/login';
import Reconciliation from './pages/recon/recon';
import RuleSets from './pages/settings/rulesets';
import DataLineage from './pages/data-lineage/data-lineage';
import NewLineage from './pages/data-lineage/new-lineage';
import EditLineage from './pages/data-lineage/edit-lineage';
import FieldLineage from './pages/data-lineage/field-lineage';
import DataDictionaryView from './pages/data-dictionary-view/data-dictionary-view';
import Profile from './pages/profile/profile';
import SuperUserPanel from './pages/super-user-panel/super-user';
import Admin from './pages/admin-panel/admin';
import ContextCheck from './pages/context/context-check';
import SchemaMonitor from './pages/schema-monitor/SchemaMonitor';
import AccessDenied from './pages/access-denied/access-denied';
import WorkflowDashboard from './pages/workflow/workflow-dashboard';
import SchemaComparison from './pages/schema-comparison/schema-comparison';
import DependencyAnalysis from './pages/dependency-analysis/dependency-analysis';
import Home from './pages/home/home';
import SessionGuard from './components/session-guard';
import {CONTEXT_ENABLED} from './config/features';

const auth = new Auth();
const {isAuthenticated} = auth;

// #628: SessionGuard wraps every authenticated route regardless of layout, so idle
// monitoring can't be silently skipped by a layout (SecuredLayoutWOMenu/AdminLayout
// never had it). Session monitoring lives here, NOT inside the individual layouts.
const AppRoute = ({component: Component, layout: Layout, ...rest}) => (
  <Route {...rest} render={(props) => isAuthenticated()===true ?
    ( <SessionGuard><Layout> <Component auth={auth} {...props} /></Layout></SessionGuard> ) :
    ( <Redirect to="/login" /> )
  } />
);

const ProtectedFeatureRoute = ({component: Component, layout: Layout, feature, permission = 'can_view', ...rest}) => (
  <Route {...rest} render={(props) => {
    if (!isAuthenticated()) return <Redirect to="/login" />;
    const inner = auth.hasPermission(feature, permission) ?
      <Component auth={auth} {...props} /> :
      <AccessDenied {...props} />;
    return <SessionGuard><Layout>{inner}</Layout></SessionGuard>;
  }} />
);

class Main extends Component {
  render() {
    return (
      <main>
        <Switch>
          <Route path="/login" render={(props) => <Login auth={auth} {...props} />} />
          <AppRoute path='/home' layout={SecuredLayout} component={Home} />
          <AppRoute path='/comparizone' layout={SecuredLayout} component={Reconciliation} />
          <AppRoute path='/rulesets' layout={SecuredLayout} component={RuleSets} />
          <ProtectedFeatureRoute path='/lineage-library/new' layout={SecuredLayout} component={NewLineage} feature='data_lineage' permission='can_create' />
          <ProtectedFeatureRoute path='/lineage-library/edit/:id' layout={SecuredLayout} component={EditLineage} feature='data_lineage' permission='can_edit' />
          <ProtectedFeatureRoute path='/lineage-library/field-lineage' layout={SecuredLayout} component={FieldLineage} feature='data_lineage' />
          <ProtectedFeatureRoute path='/lineage-library' layout={SecuredLayout} component={DataLineage} feature='data_lineage' />
          <ProtectedFeatureRoute path='/data-dictionary-view' layout={SecuredLayout} component={DataDictionaryView} feature='data_dictionary_view' />
          <AppRoute path='/profile' layout={SecuredLayout} component={Profile} />
          <AppRoute path='/settings/:module' layout={SecuredLayout} component={SuperUserPanel} />
          <AppRoute path='/settings' layout={SecuredLayout} component={SuperUserPanel} />
          <AppRoute path='/admin' layout={AdminLayout} component={Admin} />
          <AppRoute path='/adminprofile' layout={AdminLayout} component={Profile} />
          {CONTEXT_ENABLED ?
            <AppRoute path='/context' layout={SecuredLayoutWOMenu} component={ContextCheck} /> :
            <Route path='/context' render={() => <Redirect to="/home" />} />}
          <ProtectedFeatureRoute path='/schema-monitor' layout={SecuredLayout} component={SchemaMonitor} feature='schema_monitoring' />
          <ProtectedFeatureRoute path='/change-control' layout={SecuredLayout} component={WorkflowDashboard} feature='workflow' />
          <Redirect from='/workflow' to='/change-control' />
          <ProtectedFeatureRoute path='/schema-comparison' layout={SecuredLayout} component={SchemaComparison} feature='schema_comparison' />
          <ProtectedFeatureRoute path='/dependency-analysis' layout={SecuredLayout} component={DependencyAnalysis} feature='dependency_analysis' />
          <AppRoute path='/*' layout={SecuredLayout} component={Reconciliation} />
        </Switch>
      </main>
    );
  }
}

export default Main;
